{
    const inViewSections = new Set();
    const offsetMap = new Map();
    const targetMap = new Map();

    const calculateOffsetsOfSections = (sections, map) => {
        const bodyTop = document.body.getBoundingClientRect().top;

        sections.forEach(section => {
            const sectionTop = section.getBoundingClientRect().top;
            const offset = sectionTop - bodyTop;
            map.set(section, offset);
        });
    }

    const mapTargetsOfSections = (sections, map) => {
        sections.forEach(section => {
            const targets = section.querySelectorAll('[data-scroll-animation-target]');

            if (targets !== null) {
                map.set(section, targets);
            }
        });
    }

    const observeSections = (sections, observer) => sections.forEach(section => observer.observe(section));

    const intersectionCallback = entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                inViewSections.add(entry.target);
            } else {
                inViewSections.delete(entry.target);
            }
        });
    }

    const observer = new IntersectionObserver(intersectionCallback, {
        root: null,
        rootMargin: '0px 0px 50%'
    });

    const sections = document.querySelectorAll('[data-scroll-animation-container]');

    calculateOffsetsOfSections(sections, offsetMap);
    mapTargetsOfSections(sections, targetMap);
    observeSections(sections, observer);

    window.addEventListener('resize', () => {
        calculateOffsetsOfSections(sections, offsetMap);
    });

    window.addEventListener('scroll', () => {
        calculateOffsetsOfSections(sections, offsetMap);

        inViewSections.forEach(section => {
            if (offsetMap.has(section) && targetMap.has(section)) {
                const targets = targetMap.get(section);
                const offset = offsetMap.get(section);

                targets.forEach(target => {
                    const multiplierSpeed = target.dataset.scrollAnimationSpeed;
                    const rateMultiplier = multiplierSpeed ? Number(multiplierSpeed) : -0.5;
                    const rate = Math.round((window.pageYOffset - offset) * rateMultiplier);
                    const translateX = target.dataset.scrollAnimationTranslateX || '0px'

                    target.style.setProperty('transform', `translate3d(${translateX}, ${rate}px, 0px)`, 'important');
                }) 
            }
        });
    }, {passive: true});
}
